import Index from '../components/CategoryVideoOrder/Index';

let routes = {
    path: '/categoryVideoOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/categoryVideoOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/categoryVideoOrder.js